import { Injectable } from '@angular/core';
import { JwtHelperService } from '@auth0/angular-jwt';
import * as Cookie from 'js-cookie';
import moment from 'moment';
import Constants from '../../shared/constants';
import { AuthService } from '../auth/auth.service';
import { ApiService } from '@xref/ngx';
import constants from '../../shared/constants';
import { Router } from '@angular/router';
import { EditModeService } from '../edit-mode/edit-mode.service';

@Injectable()
export class TokenManagementService {
  refreshingToken: boolean;

  constructor(
    private jwtHelper: JwtHelperService,
    private auth: AuthService,
    private api: ApiService,
    private router: Router,
    private editMode: EditModeService
  ) {}

  decodeAuthToken() {
    const codedToken = Cookie.get(constants.QUESTIONNAIRE_TOKEN);

    if (codedToken != undefined) {
      return this.jwtHelper.decodeToken(codedToken);
    } else {
      return {};
    }
  }

  refreshToken() {
    const token = Cookie.get(Constants.QUESTIONNAIRE_TOKEN);

    // Exit if no token
    if (token == undefined) return;

    // If token is expired log out user since refresh calls wont work
    if (this.jwtHelper.isTokenExpired(token)) {
      this.handleExpiredToken();
      return;
    }

    // Decode token
    const decodedToken = this.jwtHelper.decodeToken(token);

    // Get token expiry and time of issue
    const exp = decodedToken.exp;
    const iat = decodedToken.orig_iat;

    // Get refresh timing is token life span divided by two
    const refreshTiming = moment.unix(exp).diff(moment.unix(iat), 'seconds') / 2;

    // Time until token expires
    const timeUntilExpire = moment.unix(exp).diff(moment(), 'seconds');

    // Refresh if token expires within half of token session length and no refresh is taking place
    if (timeUntilExpire <= refreshTiming && !this.refreshingToken) {
      this.refreshingToken = true;

      this.refreshJwt(() => {
        this.refreshingToken = false;
      }, token);
    }
  }

  handleExpiredToken() {
    if (this.router.url.search('build') >= 0) {
      this.auth.removeToken();
      this.editMode.setEditMode(false);

    } else {
      this.auth.logout();
    }
  }

  // Refresh the JWT by calling refresh endpoint and replace the session storage JWT with the new refreshed one
  refreshJwt(callback: any, token: any): any {
    const success = () => {
      // On successful call update session storage token
      // - On failure let it fail. If subsequent calls fails and the token expires the user will be logged out
      //   by regular HTTP error handling
      if (this['status'] >= 200 && this['status'] < 400) {
        // Store new JWT in session storage
        this.auth.setSessionToken(JSON.parse(this['response']).token);
      }
    };

    const error = () => {
      callback();
    };

    const postData = {
      token: Cookie.get(Constants.QUESTIONNAIRE_TOKEN)
    };

    this.api.post('v1/jwt/refresh', postData).subscribe(success, error);
  }
}
